import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import './index.css';

import { useNavigate } from "react-router-dom";
import { LanguageContext, TranslateContext, useAuth } from 'fennec-ui';

// or 'antd/dist/antd.less'

import {
  Form,
  Input,
  Select,
  Button,
  message,
  Card
} from 'antd';
import { LangSwitchContext, TranslatesContext, useLayoutWidthContext } from '../../../components/Context';
import LangSwitch from '../../../components/LangSwitch';
import { Layout } from 'antd';
import FedHeader from '../FedHeader';
import { Content } from 'antd/es/layout/layout';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

function String({ value, onChange }) {
  return (
    <Input allowClear value={value} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/\s/g, '');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

function ForgotPassword(props) {
  let navigate = useNavigate();
  const auth = useAuth();

  const { t } = useTranslation()

  const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
  const [translates, setTranslates] = useState();
  const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })

  const formRef = React.createRef();

  const [recaptchaSite, setRecaptchaSite] = React.useState("")
  const [success, setSuccess] = React.useState(false)

  let captcha = undefined;

  React.useEffect(() => {
    auth.fetch('/api/recaptcha/site').then(res => {
      if (res && res.data) {
        setRecaptchaSite(res.data);
      }
    });
  }, [])

  const handleSubmit = React.useCallback((values) => {
    auth.forgotPassword(values)
      .then(res => {
        if (!res.status) {
          if (captcha) {
            captcha.reset();
          }
          //Валидация (подумать как сделать универсально)
          //Чистим ошибки предыдущей валидации
          formRef.current.setFieldsValue(formRef.current.getFieldsValue());
          //Показываем новые ошибки
          if (res.invalid && res.invalid.errors) {
            var object = res.invalid.errors
            for (const key in object) {
              if (object.hasOwnProperty(key)) {
                const element = object[key];
                if (element && element.length) {
                  var valData = [];
                  valData.push({
                    name: key,
                    errors: [element[0].message],
                    value: (element[0].value) ? element[0].value : ""
                  })
                  formRef.current.setFields(valData);
                }
              }
            }
          }
          message.error(res.message);
        } else {
          setSuccess(true);
        }
      })
      .catch(err => {
        if (captcha) {
          captcha.reset();
        }
        console.log(err)
      })
  }, [captcha, formRef])


  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 20,
        offset: 4,
      },
    },
  };

  return (
    <TranslatesContext.Provider value={translates}>
      <TranslateContext.Provider value={t}>
        <LanguageContext.Provider value={[language, setLanguage]}>
          <LangSwitchContext.Provider value={<LangSwitch />}>
            <Layout>
              <FedHeader layout={"web"} hideLogo={true}>
                {/* <MenuOne menu={menu(status, notify)} /> */}
              </FedHeader>
              <Content style={{ padding: '6px', backgroundColor: "white" }}>
                <div style={{
                  height: "calc(100vh - 12px)",
                  backgroundColor: "white",
                  margin: "5px",
                  borderRadius: "5px"
                }}>

                  <div className="register-form" style={{ paddingBottom: "0px", textAlign: "center", maxWidth: (props.mobile) ? "300px" : "600px" }}>
                    <a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)}>
                      <img style={{ height: "70px" }} src="/resources/logo-blue.svg" alt="Logo" />
                    </a>
                  </div>

                  {!success && <Form ref={formRef} name="forgotPassword" {...formItemLayout}
                    onFinish={handleSubmit}
                    onFinishFailed={({ errorFields }) => {
                      formRef.current.scrollToField(errorFields[0].name);
                    }}
                    className="register-form"
                    style={{ maxWidth: (props.mobile) ? "300px" : "600px", paddingTop: "5px" }}

                    initialValues={{
                      genderID: '1',
                      tipTelefonaID: '1',
                    }}
                  >
                    <div style={{
                      backgroundColor: "white",
                      padding: (props.mobile) ? "0px" : "25px",
                      boxShadow: "1px 1px 8px 0px rgba(34, 60, 80, 0.2)",
                      borderRadius: "5px"
                    }}>
                      <div style={{ paddingBottom: "25px" }}>{t("forgotPassword.Для восстановления пароля, необходимо указать адрес электронной почты, зарегистрированный в social-dance.club")}</div>
                      <Form.Item label={t("forgotPassword.Адрес электронной почты")}
                        name="email"
                        rules={[
                          {
                            type: 'email',
                            message: t('forgotPassword.Введен неверный адрес электронной почты!'),
                          },
                          {
                            required: true,
                            message: t('forgotPassword.Пожалуйста, введите свой адрес электронной почты!'),
                          },
                        ]}
                      >
                        <String />
                      </Form.Item>

                      <Form.Item {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit">
                          {t("forgotPassword.Отправить")}
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>}
                  {success && <div className="register-form">
                    <Card>
                      <div>
                        {t("forgotPassword.На Ваш адрес электронной почты было отправлено письмо с инструкцией для восстановления пароля.")}
                      </div>
                      <div style={{ paddingTop: "25px" }}>
                        <a href="/login">{t("forgotPassword.Вернуться на страницу входа")}</a>
                      </div>
                    </Card>
                  </div>}
                </div>
              </Content>
              {/* <Footer style={{ textAlign: 'center', fontSize: "12px" }}>
                                        Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"
                                    </Footer> */}
            </Layout>
          </LangSwitchContext.Provider>
        </LanguageContext.Provider>
      </TranslateContext.Provider>
    </TranslatesContext.Provider>
  );

}

export default ForgotPassword;